'use strict';

import { Dialog } from './dialog.js';

export class DialogMyadsphonewebsitedialog extends Dialog {
	constructor(component_key) {
		super(component_key);
	}

	add_events() {
		super.add_events();
		jQuery('.js-myads_phone_website_learn_more, .js-molecule_myadsphonefloatingbutton, .js-vap_phone_website_dialog_trigger').on('click', (e) => {
			this.show();
		});
	}
}
